import {
  ClientReportingPeriod,
  Equipment,
  FuelPathway,
  TCIXDStandardId,
  TClientBrokerFeeRateId,
  TClientCommissionRateId,
  TClientId,
  TClientReportingPeriodId,
  TEquipmentId,
  TEquipmentTypeEERId,
  TEquipmentTypeId,
  TFSERegistrationStatusId,
  TFacilityId,
  TFinalSalePriceId,
  TFuelPathwayId,
  TProgramBrokerFeeRateId,
  TProgramId,
  TProgramRecCostId,
  TReportingPeriodTypeId,
} from '/src/lib/models';
import { DateString, Float, FloatString, Integer, IntegerString, Nullable } from '/src/lib/types';

export type TEquipmentUsageId = number;

export interface EquipmentUsage {
  battery_capacity_rating_ah: Nullable<Integer>;
  battery_capacity_rating_kwh: Nullable<Float>;
  broker_fee: FloatString;
  charge_cycles_per_shift: Nullable<FloatString>;
  ci_score: FloatString;
  cixd_reported: FloatString;
  cixd_standard_id: TCIXDStandardId;
  cixd_standard: FloatString;
  client_broker_fee_rate_id: Nullable<TClientBrokerFeeRateId>;
  client_commission_rate_id: TClientCommissionRateId;
  client_id: TClientId;
  client_program_reporting_period_id: TClientReportingPeriodId;
  client_program_reporting_period: ClientReportingPeriod;
  client_revenue: FloatString;
  comments: Nullable<string>;
  commission_earned_after_total_commissions_paid: FloatString;
  commission_earned: FloatString;
  created_at?: DateString;
  credits_generated: FloatString;
  eer: FloatString;
  ei: FloatString;
  end_reporting_quarter: DateString;
  equipment_id: Nullable<TEquipmentId>;
  equipment_type_eer_id: TEquipmentTypeEERId;
  equipment_type_id: TEquipmentTypeId;
  equipment: Equipment;
  exd_displaced: FloatString;
  facility_id: TFacilityId;
  final_sale_price_id: TFinalSalePriceId;
  final_sale_price: FloatString;
  fse_registration_status_id: TFSERegistrationStatusId;
  fuel_pathway_id: TFuelPathwayId;
  fuel_pathway: FuelPathway;
  id: TEquipmentUsageId;
  import_file_name?: Nullable<string>;
  import_row_number?: Nullable<IntegerString>;
  is_book_and_claim_applied: boolean;
  is_finalized: boolean;
  is_metered: boolean;
  is_paused: boolean;
  kwh_per_charge_cycle: Nullable<Float>;
  percent_broker_fee_rate: FloatString;
  percent_charge_return_factor: Nullable<Integer>;
  percent_charger_efficiency_rating: Nullable<Integer>;
  percent_client_commission_rate: FloatString;
  percent_depth_of_discharge: Nullable<Integer>;
  percent_total_referral_commission_rate: FloatString;
  percent_total_sales_commission_rate: FloatString;
  program_broker_fee_rate_id: Nullable<TProgramBrokerFeeRateId>;
  program_id: TProgramId;
  program_rec_cost_id: TProgramRecCostId;
  program_rec_cost: FloatString;
  rec_cost: FloatString;
  recs_required: Float;
  reporting_period_type_id: TReportingPeriodTypeId;
  shifts_per_day: Nullable<FloatString>;
  start_reporting_quarter: DateString;
  total_commissions_paid: FloatString;
  total_kwh: Nullable<FloatString>;
  total_referral_commissions_paid: FloatString;
  total_sales_commissions_paid: FloatString;
  total_value_after_rec_cost_and_broker_fee: FloatString;
  total_value_after_rec_cost: FloatString;
  total_value: FloatString;
  updated_at?: DateString;
  uses_alternate_exd_displaced_formula: boolean;
  voltage: Nullable<Integer>;
  work_days_per_quarter: Nullable<FloatString>;
  percent_uptime: Nullable<IntegerString>;
  max_site_deliverability_kw: Nullable<IntegerString>;
  [key: string]: string | number | boolean | null | undefined | FuelPathway | Equipment | ClientReportingPeriod;
}
